import React, { useMemo } from 'react'
import { Form, Text, Spacer } from 'components/atoms'
import { Formik, Field } from 'formik';
import {
  FieldCustom, FieldImageGalleryUpload, FieldSelect, FieldTextarea
} from 'components/molecules';
import PropTypes from 'prop-types'
import * as Yup from 'yup';
import styled from 'styled-components/macro'

const MetadataSchema = Yup.object().shape({
  title: Yup.string()
    .min(4, 'Mínimo de 4 caracteres')
    .max(120, 'Máximo de 120 caracteres')
    .required('Campo obrigatório'),
  description: Yup.string(),
  image: Yup.object({
    url: Yup.string(),
    alt: Yup.string(),
    title: Yup.string()
  }),
  keywords: Yup.array().of(Yup.string()).nullable()
});


const MetadataForm = ({ initialProps, onChange }) => {
  // get initial form values, only the editable props
  const initialValues = useMemo(() => {
    const {
      title, description, keywords, image
    } = initialProps
    return {
      title: title || '',
      description: description || '',
      keywords,
      image: {
        url: image,
        isLocal: false,
        alt: 'Imagem de partilha'
      },
    }
  }, [initialProps])

  // when the values change Formik runs validate so we can values changing side effects here
  // update the page json by invoking onChange(newProps)
  const handleFormChange = (newValues) => {
    const newProps = {
      ...initialProps,
      ...newValues,
      image: (newValues.image && newValues.image.url) ? newValues.image.url : null
    }
    const isValid = MetadataSchema.isValidSync(newValues)
    if (isValid) onChange(newProps)
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={MetadataSchema}
      validate={handleFormChange}
      validateOnMount
      enableReinitialize
    >
      <Form>
        <Field
          title="Título"
          name="title"
          placeholder="Title"
          info="Título da página."
          component={FieldCustom}
          maxLetters={120}
        />
        <Field
          title="Descrição"
          name="description"
          placeholder="Descrição"
          info="Descrição da página."
          component={FieldTextarea}
        />
        <Field
          name="keywords"
          placeholder=""
          title="Tags"
          component={FieldSelect}
          options={[]}
          noOptionsMessage={() => 'Escreva e pressione \'enter\' ↵'}
          formatCreateLabel={(value) => (
            <TagLabel>
              <Text modifiers={['light']}>pressione &apos;enter&apos; para adicionar a tag:</Text>
              <Spacer left="xs3">
                <Text modifiers={['xbase']}>
                  {value}
                </Text>
              </Spacer>
            </TagLabel>
          )}
          creatable
          isMulti
        />
        <Field
          title="Imagem de partilha"
          name="image"
          placeholder="Imagem de partilha"
          info="Imagem de partilha."
          component={FieldImageGalleryUpload}
        />
      </Form>
    </Formik>
  )
}

MetadataForm.propTypes = {
  initialProps: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    image: PropTypes.string,
    keywords: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  onChange: PropTypes.func.isRequired,
}

const TagLabel = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
`


export default MetadataForm
